import style from './Logo.module.scss';
import SVGDesktop from './logo.svg';
import SVGMobile from './logo-mobile.svg';

export type LogoType = {
  isHome: boolean;
  forceLarge?: boolean
};
export const Logo = ({ isHome, forceLarge = false }: LogoType): JSX.Element => {
  return (
    <div className={style.container}>
      {isHome && <h1 className="sr-only">Co-Partnership</h1>}
      {forceLarge ? (
        <SVGDesktop className={style.forcedLarge} />
      ) : (
        <>
          <SVGDesktop className={style.desktop} />
          <SVGMobile className={style.mobile} />
        </>
      )}
    </div>
  );
};
